import { setSimaSuiteComponentsLanguage } from 'sima-suite-components-vue3'
import { useI18n } from 'vue-i18n'

export enum LanguageKey {
  es = 'es',
  en = 'en',
  fr = 'fr',
  pt = 'pt',
  de = 'de',
  hu = 'hu'
}

export const defaultLocale = window.navigator.language.substring(0, 2) as LanguageKey

export const useTranslator = () => {
  const { t, locale } = useI18n()
  return {
    translate: t,
    locale: locale,
    setLanguage: (language: LanguageKey) => {
      locale.value = language
      setSimaSuiteComponentsLanguage(language)
    }
  }
}
